import _styled from '@emotion/styled/base';
import isPropValid from '@emotion/is-prop-valid';
import * as ToolbarPrimitive from '@radix-ui/react-toolbar';
import ButtonBase from '../Button/ButtonBase.js';
import { Button } from '../Button/index.js';
import { getStylesByVariant } from '../Button/styles.js';
import { shorthandSpacingCss } from '../primitives/Spacer/index.js';
import { Text } from '../Text/index.js';
import { Spacing } from '../primitives/spacing.js';
import { size, border } from '@hubble/tokens/web';

const excludedPropsFromHtml = ['stretch'];
const StyledToolbarRoot = _styled(ToolbarPrimitive.Root, {
  shouldForwardProp: prop => isPropValid(prop) && !excludedPropsFromHtml.includes(prop),
  target: "e1eckm1o7"
})("width:", ({
  stretch
}) => stretch ? '100%' : 'fit-content', ";height:", ({
  size: size$1
}) => size$1 ? size.control[size$1] : size.control.md, ";display:flex;align-items:center;flex-wrap:nowrap;gap:", Spacing.scale[0.5], ";background-color:", ({
  theme
}) => theme.colorScheme.card.background.filled, ";padding:", Spacing.scale[0.5], ";border-radius:", border.radius.full, ";", shorthandSpacingCss, ";");
const StyledBaseButton = _styled(ButtonBase, {
  target: "e1eckm1o6"
})(props => {
  const styles = getStylesByVariant(props, 'tertiary');
  delete styles[':focus'];
  return styles;
});
const StyledToolbarButton = _styled(StyledBaseButton, {
  target: "e1eckm1o5"
})("height:100%;flex-grow:1;", shorthandSpacingCss, ";");
({
  xs: size.control.xs,
  sm: size.control.sm,
  md: size.control.md,
  lg: size.control.lg
});
const StyledMenuButton = _styled(Button.Secondary, {
  target: "e1eckm1o4"
})("display:flex;height:100%;", ({
  width
}) => {
  if (width) {
    return `
        width: ${width};
        justify-content: space-between;
        padding: 0 ${Spacing.scale[1.5]} 0 ${Spacing.scale[0.5]};
        `;
  }
  return `flex-grow: 1;`;
}, " white-space:nowrap;overflow:hidden;background-color:", ({
  theme
}) => theme.colorScheme.card.background.filled, ";", shorthandSpacingCss, " svg{flex-shrink:0;margin-right:", Spacing.scale[0.5], ";transform:scale(0.8);}&[data-state='open']{svg{transform:scale(0.8) rotate(180deg);}}");
const StyledToolbarSeperator = _styled(ToolbarPrimitive.Separator, {
  target: "e1eckm1o3"
})("height:100%;width:1px;background:", ({
  theme
}) => theme.colorScheme.border.secondary, ";overflow:hidden;");
const StyledToolbarToggleGroup = _styled(ToolbarPrimitive.ToggleGroup, {
  target: "e1eckm1o2"
})("flex-grow:1;display:flex;align-items:center;gap:", Spacing.scale[0.5], ";height:100%;");
const StyledToolbarToggleButton = _styled(Button.Tertiary, {
  target: "e1eckm1o1"
})("height:inherit;&[data-state='on']{background-color:", ({
  theme
}) => theme.colorScheme.action.background.primary.neutral.enabled, ";color:", ({
  theme
}) => theme.colorScheme.action.content.primary.neutral.enabled, ";}");
const StyledToolbarLink = _styled(Text.Body, {
  target: "e1eckm1o0"
})("flex-grow:1;padding:0 ", Spacing.scale[2], ";");

export { StyledBaseButton, StyledMenuButton, StyledToolbarButton, StyledToolbarLink, StyledToolbarRoot, StyledToolbarSeperator, StyledToolbarToggleButton, StyledToolbarToggleGroup };
